export default function TextArea({ title, className, ...attributes }) {
    return (
        <>
            <label className="block text-sm font-normal text-gray-700 mb-0">
                {title}
            </label>
            <div className="mt-1">
                <textarea
                    {...attributes}
                    rows="3"
                    className={`shadow-sm focus:outline-offset-2  outline-blue-500/50  focus:ring-indigo-500 focus:border-indigo-500 mt-1 block w-full sm:text-sm border border-gray-300 rounded-md ${className}`}
                ></textarea>
            </div>
            {/* <p className="mt-2 text-sm text-gray-500">
                Brief description for your video
            </p> */}
        </>
    );
}
